// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.chart > .highcharts-container {\n  position: absolute !important;\n}\n", ""]);
// Exports
module.exports = exports;
